/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _sliders = __webpack_require__(1);

	var _sliders2 = _interopRequireDefault(_sliders);

	var _quotes = __webpack_require__(2);

	var _quotes2 = _interopRequireDefault(_quotes);

	var _animationOnScroll = __webpack_require__(3);

	var _animationOnScroll2 = _interopRequireDefault(_animationOnScroll);

	var _Parallax = __webpack_require__(4);

	var _Parallax2 = _interopRequireDefault(_Parallax);

	var _navBtn = __webpack_require__(5);

	var _navBtn2 = _interopRequireDefault(_navBtn);

	var _about = __webpack_require__(6);

	var _about2 = _interopRequireDefault(_about);

	var _headerFixed = __webpack_require__(7);

	var _headerFixed2 = _interopRequireDefault(_headerFixed);

	var _preloader = __webpack_require__(8);

	var _preloader2 = _interopRequireDefault(_preloader);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	jQuery(function () {
		// Slick Slider
		_sliders2.default.init();

		// Quotes
		_quotes2.default.init();

		// AnimationOnScroll
		_animationOnScroll2.default.init();

		// Parallax
		_Parallax2.default.init();

		// NavBtn
		_navBtn2.default.init();

		// About
		_about2.default.init();

		// Header Fixed
		_headerFixed2.default.init();

		// Lazy Load
		// LazyLoad.init();

		// Preloader
		_preloader2.default.init();

		console.log('hello');
	});
	// import LazyLoad from './_site/lazyLoad';

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var $ = jQuery.noConflict();

	'use strict';
	var Sliders = {
		/*-------------------------------------------------------------------------------
	 	# Cache dom and strings
	 -------------------------------------------------------------------------------*/
		$domSlider: $('.js-slider'),
		$domArrowLeft: $('.js-arrow-left'),
		$domArrowRight: $('.js-arrow-right'),

		/*-------------------------------------------------------------------------------
	 	# Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {

			// gallery slider
			this.$domSlider.slick({
				slidesToShow: 3,
				nextArrow: Sliders.$domArrowRight,
				prevArrow: Sliders.$domArrowLeft,
				responsive: [{
					breakpoint: 1024,
					settings: {
						slidesToShow: 1
					}
				}]
			});
		}
	};

	exports.default = Sliders;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var $ = jQuery.noConflict();

	'use strict';
	var Quotes = {
		/*-------------------------------------------------------------------------------
	 	# Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {

			var quoteItem = $('.js-quote-item');
			var quoteImage = $('.js-quote-img');
			var quoteContent = $('.js-quote-content');
			var classActive = 'active';

			quoteItem.each(function (i) {
				$(this).hover(function () {
					var currentItem = $(this);
					quoteItem.not(currentItem).removeClass(classActive);
					currentItem.addClass(classActive);

					var currentImage = quoteImage.eq(i);
					quoteImage.not(currentImage).removeClass(classActive);
					currentImage.addClass(classActive);

					var currentContent = quoteContent.eq(i);
					quoteContent.not(currentContent).removeClass(classActive);
					currentContent.addClass(classActive);
				});
			});
		}
	};

	exports.default = Quotes;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var $ = jQuery.noConflict();

	'use strict';
	var AnimateOnScroll = {

	    /*-------------------------------------------------------------------------------
	    	# Initialize
	    -------------------------------------------------------------------------------*/
	    init: function init() {
	        var $window = $(window);

	        function animateElInit(selector) {
	            var $animationEl = selector;

	            var visibleClass = 'is-visible';

	            function checkIfInView() {
	                var windowHeight = $window.height();
	                var windowTopPosition = $window.scrollTop();
	                var windowBottomPosition = windowTopPosition + windowHeight;

	                $animationEl.each(function () {
	                    var $element = $(this);
	                    var elementHeight = $element.outerHeight();
	                    var elementTopPosition = $element.offset().top + windowHeight / 10;
	                    var elementBottomPosition = elementTopPosition + elementHeight;
	                    var animationDelay = $(this).attr('data-slide-delay');

	                    // check to see if this current container is within viewport
	                    if (elementBottomPosition >= windowTopPosition && elementTopPosition <= windowBottomPosition) {
	                        setTimeout(function () {
	                            $element.addClass(visibleClass);
	                        }, animationDelay);
	                    }
	                });
	            }

	            $window.on('scroll resize', checkIfInView);
	            $window.trigger('scroll');
	        }

	        var animateEl = $('.is-animate');

	        if ($window.innerWidth() > 767) {
	            setTimeout(function () {
	                animateElInit(animateEl);
	            }, 400);
	        }
	    }
	};

	exports.default = AnimateOnScroll;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var $ = jQuery.noConflict();

	'use strict';
	var Parallax = {

		/*-------------------------------------------------------------------------------
	 	# Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {
			var $window = $(window);

			function parallaxEl() {
				var $parallax = $('.js-parallax');
				var paraVals = {};

				function parallaxElVals() {
					$parallax.each(function (index, el) {
						$(el).removeAttr('style');
						var speed = $(el).attr('data-speed') * 10;
						var offset = $(el).offset().top / speed;

						paraVals['speed' + index] = speed;
						paraVals['offset' + index] = offset;
					});
				};

				function parallaxElMove(el, speed, offset) {
					var movement = -($window.scrollTop() / speed);
					el.css({
						transform: 'translate3d(0,' + (movement + offset) + 'px, 0'
					});
				};

				function parallaxElInit() {
					if ($parallax.length && window.innerWidth > 1024 && navigator.userAgent.match(/iPad/i) == null) {
						$parallax.each(function (index, el) {
							parallaxElMove($(el), paraVals['speed' + index], paraVals['offset' + index]);
						});
					} else {
						$parallax.each(function () {
							$(this).css({
								transform: ''
							});
						});
					}
				}

				$window.on('scroll resize', function () {
					parallaxElVals();
					parallaxElInit();
				});

				$window.trigger('scroll');
			}

			if ($window.innerWidth() > 767) {
				parallaxEl();
			}
		}
	};

	exports.default = Parallax;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var $ = jQuery.noConflict();

	'use strict';
	var NavBtn = {
		/*-------------------------------------------------------------------------------
	 	# Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {
			var mainHeaderWrap = $('.js-header-wrap');
			var menuBtn = $('.js-menu-btn');
			var $body = $('body');

			if ($(window).width() < 1200) {
				menuBtn.on('click', function (e) {
					e.stopPropagation();
					mainHeaderWrap.slideToggle();
					menuBtn.toggleClass('open');
					$body.toggleClass('noscroll');
				});
			}
		}
	};

	exports.default = NavBtn;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
					value: true
	});
	var $ = jQuery.noConflict();

	'use strict';
	var About = {
					/*-------------------------------------------------------------------------------
	    	# Initialize
	    -------------------------------------------------------------------------------*/
					init: function init() {
									var $window = $(window);
									var aboutItem = $('.js-about-item');
									var aboutImg = $('.js-about-img');

									if ($window.width() > 767) {
													aboutItem.hover(function () {
																	var $this = $(this);
																	var curentAboutItem = $this.attr('data-about-img');
																	var curentAboutSel = $('.' + curentAboutItem);
																	var curentAboutImage = curentAboutSel.find('img');
																	var activeImageSrc = curentAboutImage.attr('data-src');
																	var inactiveImageSrc = curentAboutImage.attr('src');

																	curentAboutSel.addClass('active');
																	aboutItem.removeClass('active');
																	$this.addClass('active');

																	curentAboutImage.attr('src', activeImageSrc);
																	curentAboutImage.attr('data-src', inactiveImageSrc);
													}, function () {
																	var $this = $(this);
																	var curentAboutItem = $this.attr('data-about-img');
																	var curentAboutSel = $('.' + curentAboutItem);
																	var curentAboutImage = curentAboutSel.find('img');
																	var inactiveImageSrc = curentAboutImage.attr('data-src');
																	var activeImageSrc = curentAboutImage.attr('src');

																	curentAboutSel.removeClass('active');
																	$this.removeClass('active');

																	curentAboutImage.attr('src', inactiveImageSrc);
																	curentAboutImage.attr('data-src', activeImageSrc);
													});
									} else {
													aboutImg.each(function (i, el) {
																	var curentAboutImage = $(el).find('img');
																	var activeImageSrc = curentAboutImage.attr('data-src');
																	var inactiveImageSrc = curentAboutImage.attr('src');

																	curentAboutImage.attr('src', activeImageSrc);
																	curentAboutImage.attr('data-src', inactiveImageSrc);
													});
									}
					}
	};

	exports.default = About;

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var $ = jQuery.noConflict();

	'use strict';
	var HeaderFixed = {
	    /*-------------------------------------------------------------------------------
	    	# Initialize
	    -------------------------------------------------------------------------------*/
	    init: function init() {
	        var $window = $(window);
	        var header = $('.header');
	        var classFixed = 'header-fixed';

	        if ($window.width() > 1024) {
	            $window.on('scroll', function () {
	                if ($window.scrollTop() > 100) {
	                    header.addClass(classFixed);
	                } else {
	                    header.removeClass(classFixed);
	                }
	            });
	        }
	    }
	};

	exports.default = HeaderFixed;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var $ = jQuery.noConflict();

	'use strict';
	var Preloader = {
		/*-------------------------------------------------------------------------------
	 	# Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {
			var preloader = $('.preloader');

			setTimeout(function () {
				preloader.addClass('loaded');
			}, 3000);
		}
	};

	exports.default = Preloader;

/***/ })
/******/ ]);